// import React, { useState, useEffect } from "react";
// import { get } from "lodash";
// import {css} from '@emotion/react';
// import API_SERVICE from "src/utils/axios";
// import { Box, Avatar, Badge } from "@mui/material";
// import { useRouter } from "next/router";
// import {NeedHelp} from "src/modules/home/needHelp"
// import { DownloadApp } from "src/modules/home/downloadApp";
// import { ExploreTemplate } from "src/modules/home/exploreTemplate";
// import { HomeHeading } from "src/modules/home/heading";
// import { NoShoot } from "src/modules/home/noShoot";
// import { RecentProjects } from "src/modules/home/RecentProjects";
// import { TemplateEditor } from "src/modules/home/templateEditor";
// // components
// import Page from "../../components/Page";
// // hooks
// import useSettings from "../../hooks/useSettings";
// import { useSelector, useDispatch } from "react-redux";
// // layouts
// import Layout from "../../layouts";
// import { useTheme } from "@mui/material/styles";
// import { RecommendedTemplate } from "src/modules/home/RecommendedTemplates";
// import { searchJobs } from "src/redux/reducers/jobs.reducer";
// import useAuth from "src/hooks/useAuth";
// import { getInstagramDoMyShoot, getTemplates } from "src/redux/reducers/template.reducer";
// import { setNavPath, setReferredCountryCode,setReferredEmailId, setReferredPhoneNo } from "src/redux/reducers/appRedirect.reducer";
// import { InstagramTemplate } from "src/modules/home/InstagramTemplate";
// import { getCompletedJobs } from "../../services/jobs";
// import LoadingScreen from "src/components/LoadingScreen";

// // ----------------------------------------------------------------------

// HomePage.getLayout = function getLayout(page) {
//   return <Layout>{page}</Layout>;
// };

// // ----------------------------------------------------------------------

// export default function HomePage() {
//   const { themeStretch } = useSettings();
//   const { user } = useAuth();
//   const { jobSearch, isLoading } = useSelector((state) => state.jobs);
//   const {navPath} = useSelector(state=>state.appRedirect);
//   const [headset, setHeadset] = useState(true);
//   const [notificationValue, setNotification] = useState();
//   const [downloadJobOrder,setDownloadJobOrder] = useState([]);
//   const [isFetchingStarted,setFetchingStarted] = useState(false);
//   const dispatch = useDispatch();
//   const router = useRouter();

//   const theme = useTheme();


//   const getNotification = async () => {
//     const data = await API_SERVICE.get(`${process.env.NEXT_PUBLIC_API_URL_V2}v1/api/chat/getRecentTicket/0/25/?userId=${get( user,["user", "_id"],  "" )}`);
//     const totalUserCount = data.data?.data?.reduce( (sum, item) => sum + +item.unreadChatCount, 0);
//     const genericData = await API_SERVICE.get( `${process.env.NEXT_PUBLIC_API_URL_V2}v1/api/chat/getExternalChatUnreadCount`);
//     const genericChatCount = genericData.data?.data?.genericChat;
//     setNotification(totalUserCount + genericChatCount);
//   };

//   const fetchTemplateList = () => {
//     const filters = {
//       productType: [],
//       imageFormat: [],
//       category: [],
//     };
//     dispatch(getTemplates(0, "", [], filters));
//   };
  
//   const fetchCompletedJob = async( ) => {
//     try{
//       setFetchingStarted(true);
//       const response = await getCompletedJobs(0,2,'Download');
//       setDownloadJobOrder(response.data?.data?.suggestionList || []);
//     }catch(error){
//       console.error("error in fetching job",error);
//     }finally{
//       setFetchingStarted(false);
//     }
//   };

//   React.useEffect(() => {
//     fetchTemplateList();
//     fetchCompletedJob();
//     dispatch(searchJobs("",0,2));
//     getInstagramDoMyShoot()();
//   }, []);

//   useEffect(()=>{
//     getNotification();
//   },[notificationValue]);



//   return (
//     <Page title="Home" sx={{width:'100%'}}>
//       <div  css={styles.container} >
//         <HomeHeading />
//         <Box ml={3} mr={3}>
//           {(user?.user?.meta_data?.isAppInstall === false || user?.user?.hasJobs === false) && 
//           <DownloadApp userdata={user?.user} />
//           }

//           { (Object.keys(user?.user || {}).length > 0 && user?.user?.hasJobs === false && user?.user?.meta_data?.isAppInstall === true) &&
//             <NoShoot />}
          
//           {downloadJobOrder?.length > 0 && (
//             <RecentProjects downloadJobOrder={downloadJobOrder} />
//           )}
//           {downloadJobOrder?.length > 0 &&  <RecommendedTemplate downloadJobOrder={downloadJobOrder} />}
//           <ExploreTemplate />
//           <TemplateEditor />
//           <InstagramTemplate />
//           <Badge
//               badgeContent={notificationValue !== undefined ? notificationValue : 0}  
//               color="primary"
//               overlap="circular"
//               sx={{ position: 'fixed',bottom: '55px', right: '25px', }}
//             >
//               <Avatar
//                 onClick={() => {
//                   setHeadset(!headset);
//                 }}
//                 sx={{ cursor: "pointer" }}
//                 style={{
//                   position: 'fixed',
//                   bottom: '20px',
//                   right: '20px',
//                 }}
//                 src={headset ? "/images/headset.svg" : "/images/closeChat.svg"}
//               />
//             </Badge>
//           {!headset ? <NeedHelp getNotification={getNotification} /> : <></>}
//         </Box>
//       </div>
//     </Page>
//   );
// }


// const styles = {
//   container:css`
//    background-color: #F3F3F3;
//    font-family:'Objectivity';
//    border-top:1px solid #EEE;
//   `
// }

import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react'
import LoadingScreen from "src/components/LoadingScreen";

const home = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const waitForQuery = async () => {
      await new Promise((resolve) => setTimeout(resolve, 10));
      setIsLoading(false);
    };
    waitForQuery();
  }, []);

  useEffect(()=>{
   if(!isLoading){
     router.push({
       pathname: '/dashboard/homePage',
       query: router.query
     });
  }
  },[router.query, isLoading]);

  return (
    <LoadingScreen />
  )
}

export default home

